import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { BasicDialog } from '../../../components/Dialog/BasicDialog';
import { FormFieldsContainer } from '../../../components/Form/FormComponents';
import { FormFactoryWithStandardLayout } from '../../../components/Form/FormFactory';
import { StickyFormButtons } from '../../../components/Form/StickyFormButtons';
import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { IListDataModel } from '../../../data-models/list.data-model';
import { MoveListCompanyPayload, useMoveListCompanyFormSchema } from '../../../schemas/CompanyList.schema';
import { schemaToFormFields } from '../../../util/schema-utils';
import { createFormFromFieldsArray } from '../../../view-models/form.view-model';
import { useMoveListCompanyFormAction } from './MoveListItemState';

interface IMoveListItemProps {
  company: ICompanyDataModel;
  sourceList: IListDataModel;
  onClose: () => void;
}

export function MoveListItemModal({ company, sourceList, onClose }: IMoveListItemProps) {
  return (
    <BasicDialog open={true} onClose={onClose} title={`Move ${company.name}`}>
      <MoveListItemForm company={company} sourceList={sourceList} onClose={onClose} />
    </BasicDialog>
  );
}

function MoveListItemForm({ company, sourceList, onClose }: IMoveListItemProps) {
  const schema = useMoveListCompanyFormSchema(sourceList.id);
  const fields = schemaToFormFields(schema);
  const { onSubmit, loading } = useMoveListCompanyFormAction({ company, sourceList, onClose });

  const methods = useForm<Pick<MoveListCompanyPayload, 'targetListId'>>({
    defaultValues: {},
    resolver: yupResolver(schema),
  });

  const form = createFormFromFieldsArray(fields);
  return (
    <FormProvider {...methods}>
      <FormFieldsContainer>
        <FormFactoryWithStandardLayout form={form} />
      </FormFieldsContainer>
      <StickyFormButtons onSubmit={methods.handleSubmit(onSubmit)} onCancel={onClose} loading={loading} />
    </FormProvider>
  );
}
